import { useCallback, useState } from 'react'

export const useDrawer = (defaultVisible?: boolean) => {
	const [ visible, setIsVisible ] = useState(defaultVisible || false)
	const hide = useCallback(() => {
		setIsVisible(false)
	}, [])

	const show = useCallback(() => {
		setIsVisible(true)
	}, [])

	const toggle = useCallback(
		() => {
			setIsVisible((v) => {
				return !v
			})
		},
		[ visible ]
	)

	return {
		hide,
		visible,
		show,
		toggle
	}
}
